//React & Friends
import React, { useState, useEffect, useContext, useRef } from 'react';


//Revise all the rest of this later
//TO DO, UPDATE REACT-ROUTER SO WE CAN USE USENAVIGATE
import { v4 as uuidv4 } from 'uuid';
import axios from "axios";


//StatusBar
import SaveIcon from '@mui/icons-material/Save';
import PendingIcon from '@mui/icons-material/Pending';
import {
	newStatus,
	setStatusTimeout
} from '../FlexiGrid/features/statusbar/statusbarSlice';

//DB
var dbendpoint = process.env.REACT_APP_DB_API4;



function SaveChanges(localstate, configuration, UpdateState, dispatch, history){
	//const history = useHistory();
	//Try: Clear any error messages on load of any item:
	dispatch(setStatusTimeout(0));

	//Axios Post Options
	const postoptions = {
		withCredentials: true,
		withXSRFToken: true,
		crossDomain: true,
		mode: "no-cors",
		timeout: configuration.shortposttimeout,
	};


	let postdata = {
		item: localstate.itemdata,
		dbmodel:configuration.dbmodel,
		dbkey:configuration.dbkey,
		dbkeyvalue:configuration.dbkeyvalue
	}
	if (localstate.deleteitem) {
		postdata.deleteitem = true;
	}
	axios.post(dbendpoint + configuration.updateapiendpoint, postdata, postoptions).then(res => {
		//API should be setup to send 200 response with status. Merge paginated requests.
		if (res.status === 200) {
			//If ValidateUser() fails to verify user, it sends back 'login' error. 
			if (res.data.Status === "login") {
				//Not logged in. Reload page causes redirect to /login
				window.location.reload(false);
			}
			//All new API calls should return a status.
			if (res.data.Status === "Success") {
				//btnSave.current.style.display="";
				//btnPendingSave.current.style.display="none";
				//Attempt to replace: btnSave.current.disabled = true;
				localstate.pendingsaves = false;
				localstate.pendingupdate = false;
				//localstate.dbreload = false; //Item views don't need this.
				UpdateState(localstate);
				dispatch(newStatus({
					type: "itemsaved",
					msg: '',
					show: true,
					settimeout: true, //This option allows for a timeout after the final item is pass/failed
					timeout: 0, //Initiated on final item 
					itemtype: 'items', //Labels your save types such as items, products, skus, parts
					finished: 0,
					percent: "0%",
					total: 0,
					pass: 0,
					fail: 0,
					faillist: [], //Can take simple values,
					faillinks: [], //Can take links to things like items or products.
					timeoutid: false,
					errors: [] //Can take strings
				}));
				dispatch(setStatusTimeout(300)); //Seconds
			}
			if (res.data.Status === "Deleted") {
				history.push(configuration.parentitemurl);
				//dispatch(setErrorTimeout(0));
			}
			if (res.data.Status === "Undeleted") {
				localstate.dbreload = true;
				localstate.itemloaded = false;
				UpdateState(localstate);
			}
			if (res.data.Status === "Failure") {
				dispatch(newStatus({
					type: "itemnotsaved",
					msg: res.data.message,
					show: true,
					settimeout: true, //This option allows for a timeout after the final item is pass/failed
					timeout: 0, //Initiated on final item 
					itemtype: 'items', //Labels your save types such as items, products, skus, parts
					finished: 0,
					percent: "0%",
					total: 0,
					pass: 0,
					fail: 0,
					faillist: [], //Can take simple values,
					faillinks: [], //Can take links to things like items or products.
					timeoutid: false,
					errors: [] //Can take strings
				}));
				dispatch(setStatusTimeout(300));
			}
		} else {
			//Non-200 message from server.
			// dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" }));
			// dispatch(setErrorTimeout(15));
		}
	});
}

export default SaveChanges;